const filters = {
  /**
   * 格式化时间戳
   * @param date
   * @param format
   * @returns {*}
   */
  formatDate: (date, format) => {
    if (date === '' || date === null) {
      return '';
    }
    if (!isNaN(date)) {
      return formatDate(date, format);
    } else {
      return '';
    }
  },
  /**
   * 格式化订单状态
   * @param status
   * @returns {string}
   */
  formatOrderStatus: (status) => {
    switch (status) {
      case '01' :
        return '待付款';
      case '02' :
        return '待发货';
      case '03' :
        return '待领货';
      case '04' :
        return '已完成';
      case '05' :
        return '交易完成';
    }
  },
  /**
   * 格式化保留两位小数
   * @param num
   * @param unit
   * @returns {string}
   */
  formatToFixed2: (num, unit) => {
    num = parseFloat(num);
    if (!isNaN(num)) {
      if (unit) {
        return num.toFixed(2) + unit;
      } else {
        return num.toFixed(2);
      }
    } else {
      return '';
    }
  },
  /**
   * 格式化限制长度
   * @param str
   * @param limit
   * @returns {*}
   */
  formatLimitLength: (str, limit) => {
    const len = str.length;
    if (limit) {
      return str.substring(0, limit) + '...';
    } else {
      if (len > 10) {
        return str.substring(0, 10) + '...';
      } else {
        return str;
      }
    }
  },
  /**
   * 格式化银行卡
   * @param num
   * @returns {string}
   */
  formatBankcard: (num) => {
    num += '';
    if (num.length >= 16) {
      const head = num.substring(0, 4);
      const tail = num.substring(num.length - 3, num.length);
      let encryptNum = num.substring(4, num.length - 3);
      encryptNum = encryptNum.split('');
      for (let i = 0; i < encryptNum.length; i++) {
        if (encryptNum[i] !== ' ') {
          encryptNum[i] = '*'
        }
      }
      encryptNum = encryptNum.join('');
      return head + encryptNum + tail;
    } else {
      return num;
    }
  }
};

/**
 * 格式化时间戳
 * @param date
 * @param format
 * @returns {string}
 */
function formatDate (date, format) {
  const formatDate = new Date(date);
  const year = formatDate.getFullYear();
  const month = complement(formatDate.getMonth() + 1);
  const day = complement(formatDate.getDate());
  const hour = complement(formatDate.getHours());
  const minute = complement(formatDate.getMinutes());
  const seconds = complement(formatDate.getSeconds());
  if (format) {
    return year + '-' + month + '-' + day + ' ' + hour + ' : ' + minute + ' : ' + seconds;
  } else {
    return year + '-' + month + '-' + day;
  }
}

function complement (val) {
  val = parseInt(val);
  if (val < 10) {
    return '0' + val;
  } else {
    return val;
  }
}

export default {
  install: function (Vue, options) {
    for (const i in filters) {
      Vue.filter(i, filters[i]);
    }
  }
};
